export const convertUrlToNewSite = (url: string) => {
    return url.replace(`${process.env.NEXT_PUBLIC_MAGENTO_SITE_URL}`, `${process.env.NEXT_PUBLIC_SITE_URL}`);
};

//this function remove everything before the first single slash(/) of a url string
//ex: https://www.abc.com/my-link/abc -> /my-link/abc (still works without protocol or www)
//ex: abc/def.com -> /def.com; /abc/def.com -> /abc/def.com
export const getUrlPath = (absoluteUrl: string): string => {
    if (!absoluteUrl?.length) return '#';

    return absoluteUrl.replace(/^(.*?\/\/)?([^/]*\/)/, '/');
};

export const getBaseWebsiteUrl = (path: string) => {
    return (process.env.NEXT_PUBLIC_BASE_SHOP_URL_ENDPOINT ?? 'https://www.kidsplaza.vn') + path;
};
